import { Text, Heading } from "../../components";
import React from "react";

export default function DemoVideoSection() {
  return (
    <>
      {/* demo video section */}
      <div className="mt-[98px]">
        {/* Header Section */}
        <div className="flex flex-col items-center justify-center bg-gray-300_01 py-16 md:py-10 sm:py-5 px-5">
          <div className="max-w-screen-lg flex flex-col items-center gap-5 text-center">
            <Heading
              as="h2"
              className="text-[46px] font-bold text-color_style-01_neutrals-grey800 md:text-[36px] sm:text-[30px]"
            >
              Want to watch a short demo video?
            </Heading>
            <Text
              size="text11xl"
              as="p"
              className="text-[26px] font-normal leading-10 text-blue_gray-700_01 md:text-[22px] sm:text-[18px]"
            >
              A small demo video that would help you get an overview of the system, helping you decide for a consultation.
            </Text>
          </div>
        </div>
        <div className=" flex justify-center bg-gray-100">
          <div className="relative w-full max-w-screen-lg aspect-w-16 aspect-h-9">
            <video
              className="w-full h-full object-cover"
              controls
              poster="images/img_image_53_844x1440.webp" // optional image placeholder
            >
              <source src="/videos/Zwilling video_cropped.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          
        </div>
      </div>
    </>
  );
}
